import GLightbox from 'glightbox';

export const init = ($target) => {
	const regionSelect = $('.js-form-region');
	const districtSelect = $('.js-form-district');

	function regionChange(params) {
		const $this = $(this);
		const $form = $this.closest('.js-form-ia');
		const $result = $form.find('.js-form-result');

		if ($this.val() === 'js-choose') {
			const districtSel = $form.find('.js-form-district');
			districtSel.attr('disabled', 'disabled');
			districtSel.attr('aria-disabled', true);
			districtSel.html('<option value="js-choose">' + districtSel.data('option') + '</option>');
			$result.empty();
		} else {
			const districtSel = $form.find('.js-form-district');
			$.ajax({
				url: $this.val(),
				success: function (response) {
					districtSel.empty();
					$.each(response, function (key, value) {
						let distributor;
						if (value.distributor) {
							distributor = 'data-title="' + value.distributor + '" ';
						}
						districtSel.append('<option ' + distributor + ' value=' + value.target + '>' + value.district + '</option>');
					});
				},
			});
			districtSel.removeAttr('disabled');
			districtSel.removeAttr('aria-disabled');
		}
	}
	function districtText(params) {
		const $this = $(this);
		const boilers = $this.hasClass('js-form-district-boilers');
		const $form = $this.closest('.js-form-ia');
		const $result = $this.closest('.js-distributor-iaform').siblings('.js-form-result');
		const $title = $form.find('.js-distributor-title');
		const title = $this.find('option:selected').data('title');
		if ($this.val() === 'js-choose') {
			$result.empty();
			$title.empty();
		} else {
			if (boilers) {
				$('body').append(`<a id="tmpLink" class="js-scroll" href="${$this.val()}">&nbsp;</a>`);
				$('#tmpLink')[0].click();
				$('#tmpLink')[0].remove();
			} else {
				const districtTitle =
					'<p class="h5 item-icon u-color-turquoise u-pt-32"><span class="item-icon__icon"><span class="icon-svg icon-svg--location" aria-hidden="true"><svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="/img/bg/icons-svg.svg#icon-location" width="100%" height="100%" focusable="false"></use></svg></span></span><span class="item-icon__text">Váš distributor je ' +
					title +
					'</span></p>';
				const districtSel = $form.find('.js-form-district');
				$.ajax({
					url: $this.val(),
					success: function (response) {
						$title.html(districtTitle);
						$result.html(response);
						$result[0].dispatchEvent(new Event('contentload'));
					},
				});
				districtSel.removeAttr('disabled');
				districtSel.removeAttr('aria-disabled');
			}
		}
	}

	regionSelect.on('change', regionChange);
	districtSelect.on('change', districtText);
};
